import React from 'react';

interface ConfirmLogoutDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonText?: string;
}

const ConfirmLogoutDialog: React.FC<ConfirmLogoutDialogProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmButtonText = 'Hapus',
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className='fixed inset-0 bg-black bg-opacity-70 z-[200] backdrop-blur-sm' onClick={onCancel} />
      <div className='fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#1c243b] p-6 rounded-lg shadow-xl z-[201] w-96'>
        <h3 className='text-xl font-semibold text-white mb-2'>{title}</h3>
        <p className='text-gray-300 mb-6'>{message}</p>
        <div className='flex justify-end space-x-3'>
          <button
            className='px-4 py-2 bg-[#2a334a] text-gray-300 rounded-md hover:bg-[#344058] transition-colors'
            onClick={onCancel}
          >
            Batal
          </button>
          <button className='px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors' onClick={onConfirm}>
            {confirmButtonText}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmLogoutDialog;
